import React, { Component } from 'react';
import App from '../components/App';

export default class AppContainer extends Component {
  render() {
    return <App />;
  }
}
